module.exports = __webpack_public_path__ + "Gotham-Medium.6d02b45750c0179bf03f.svg";


//////////////////
// WEBPACK FOOTER
// /code/frontend/src/assets/fonts/Gotham-Medium.svg
// module id = ../../../../../src/assets/fonts/Gotham-Medium.svg
// module chunks = 2